<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("report_commission") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
                        <div class="row">
                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        class="form-control datepicker"
                                        v-model="startDate"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        class="form-control datepicker"
                                        v-model="endDate"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

							<div class="col-md-2">
								<base-input>
								<el-select
									v-model="productId"
									placeholder="สินค้า"
									filterable
								>
									<el-option
										v-for="item in ProductTable"
										:key="item.id"
										:label="item.name"
										:value="item.id"
									>
									</el-option>
								</el-select>
								</base-input>
							</div>
							<div class="col-auto">

								
								<base-button
                                    size="md"
                                    type="primary"
                                    @click="handleProductAdd()"
                                >
                                    เพิ่มสินค้า
                                </base-button>
								<base-button
                                    size="md"
                                    type="primary"
                                    @click="handleProductClear()"
                                >
                                    เคลียสินค้า
                                </base-button>
								-
                                <base-button
									:loading="isLoadding"
                                    size="md"
                                    type="primary"
                                    @click="handleSearch()"
                                >
                                    Search
                                </base-button>
                                <base-button
                                    size="md"
                                    type="primary"
                                    @click="handleDownloadCommissionXLSX()"
									v-if="commissionTable.length != 0"
                                >
                                    Export Commission
                                </base-button>
                                <base-button
                                    size="md"
                                    type="primary"
                                    @click="handleDownloadOrderDetailXLSX()"
									v-if="orderDetailTable.length != 0"
                                >
                                    Export OrderDetail
                                </base-button>
                            </div>
                        </div>
						<div class="row">
							<div class="col-md-12">
								

								<template v-for="item in productSelected">
									<span class="badge badge-info mr-1" :key="item.id || item.name">{{item.name}}</span>
								</template>

							</div>
						</div>
                    </template>
                    <div>
						<div class="row">
							<div class="col ml-4" v-if="reportDatum != 0">
								รวม : {{ FormatCurrency(reportDatum)}}
							</div>

						</div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                            @sort-change="sortChange"
                            @selection-change="selectionChange"
                        >
                            <el-table-column
                                v-for="column in tableColumns"
                                :key="column.label"
                                v-bind="column"
                            >
                            </el-table-column>

                            <!-- <el-table-column
				  min-width="200px"
				  align="right"
				  :label="$t('actions')"
				>
				  <div slot-scope="{ $index, row }" class="d-flex">
					<base-button
					  @click.native="handleDetail($index, row)"
					  class="edit"
					  type="warning"
					  size="sm"
					  icon
					>
					  <i class="text-dtac-bt fa fa-edit"></i>
					  Detail
					</base-button>
				  </div>
				</el-table-column> -->
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class=" col-12 d-flex justify-content-center justify-content-sm-between flex-wrap "
                        v-if="queriedData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>
<script>

import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
  import { read, utils, writeFile } from 'xlsx'

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            PaymentMethodTypeTable: "PaymentMethod/getPaymentMethodTypeTableWithAll",
            OrderStatusTable: "Order/OrderStatusTableWithAllPayment",
            reportDatum: "Report/getReportDatum",
            UserTable: "User/getData",
			ProductTable: "Product/getDataWithAll",
        }),
		SaleChannelTypeTable(){
			return [
				{id:1,name:"บริษัท"},
				{id:2,name:"ตัวแทน"},
			]
		},
		OptionUserTable: function() {
			return [{ UserID: 0, fname: "-- พนักงาน --",lname:"" }, ...this.UserTable]
        },
		SaleChannelTypeTableWithAll(){
			return [{id:0,name:"-- ประเภทช่องทางการขาย -- "}].concat(this.SaleChannelTypeTable);
		},
		tableData: function() {
			if (this.commissionTable.length == 0) {
				return []
			}

			return this.commissionTable.map((item)=>{
				// item container array of object, convert array to column
				let obj = {}

				item.product_name.forEach((element,index)=>{
					obj[element + "_" + "COD"]  = item.value_cod[index]
					obj[element + "_" + "DISCOUNT_COD"]  = item.value_discount_cod[index]
					obj[element + "_" + "TRANSFER"]  = item.value_transfer[index]
					obj[element + "_" + "DISCOUNT_TRANSFER"]  = item.value_discount_transfer[index]
				})

				// add obj column to item
				return Object.assign({
					Name : item.name,
					Commission : item.commission,
					PayAmountCOD : item.pay_amount_cod,
					DiscountCOD : item.discount_cod,
					PayAmountTransfer : item.pay_amount_transfer	,
					DiscountTransfer : item.discount_transfer,
				},obj)

			})
		},
        tableColumns: function() {


            let header =  [
                {
                    prop: "Name",
                    label: this.$t("order_user"),
                    minWidth: 90,
                    sortable: true
                },
                {
                    prop: "Commission",
                    label: "ค่าคอมมิชชั่น",
                    minWidth: 90,
                    sortable: true
                },
				{
                    prop: "PayAmountTransfer",
                    label: "ยอดโอนเงิน",
                    minWidth: 90,
                    sortable: true
                },
				{
                    prop: "PayAmountCOD",
                    label: "ยอดปลายทาง",
                    minWidth: 90,
                    sortable: true
                },
            ];

			// fetch column from commissionTable first item
			if (this.commissionTable.length > 0) {
				this.commissionTable[0].product_name.forEach((item,index)=>{
					// push cod
					header.push({
						prop: item + "_" + "COD",
						label: item + " COD",
						minWidth: 90,
						sortable: true
					})

					// push discount cod
					header.push({
						prop: item + "_" + "DISCOUNT_COD",
						label: item + " Discount COD",
						minWidth: 90,
						sortable: true
					})

					// push transfer
					header.push({
						prop: item + "_" + "TRANSFER",
						label: item + " Transfer",
						minWidth: 90,
						sortable: true
					})

					// push discount transfer
					header.push({
						prop: item + "_" + "DISCOUNT_TRANSFER",
						label: item + " Discount Transfer",
						minWidth: 90,
						sortable: true
					})
				})
			}

			// add column to header
			return header
        },
		params: function(){
			return {
				time_from: this.startDate,
				time_to: this.endDate,
				product: this.productSelected.map((item)=>{
					return item.id
				}),
				order_status : [115,121,122,130]
			}
		}
    },
    data() {
        return {
            propsToSearch: ["Name"],
            selectedRows: [],
            SearchData: "",
            startDate: "",
            endDate: "",
            paymentMethodType: 0,
            orderStatus: 0,
			saleChannelType:0,
			userId : 0,
			productId:0,
			productSelected:[],
			isLoadding:false,
			commissionTable: [],
			orderDetailTable: [],
			ignoreCache : false,
        };
    },
    mounted() {

		this.listProduct({status:1,platform_id:1});
        this.startDate = moment()
            .add(-30, "days")
            .format("YYYY-MM-DD");
        this.endDate = moment().format("YYYY-MM-DD");
    },
    methods: {
        ...mapActions({
            listData: "Report/listCommission",
            listUser: "User/listData",
            listProduct: "Product/listDataV1",
        }),
        handleSearch() {
			if (this.productSelected.length == 0) {
				swal.fire({
					title: "กรุณาเลือกสินค้าที่ต้องการคิดค่าคอมมิชชั่น",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
            		buttonsStyling: false,
				  });

				return
			}

			this.commissionTable = []
			this.orderDetailTable = []

			this.isLoading = true
			swal.fire({
				title: this.$t(`processing`),
				type: "info",
				allowEscapeKey: false,
				allowOutsideClick: false,
				onOpen: () => {
					swal.showLoading();
				}
			  });


			let poll = async () => {
				try {
					let res = await this.listData(this.params);
					// check status code
					console.log("resonse",res)
					if (res.data.Datum.state == 1) {
						// close swal
						swal.close();
						this.isLoadding = false;
						this.commissionTable = res.data.Datum.commissions
						this.orderDetailTable = res.data.Datum.order_product_detail

					} else if (res.data.Datum.state == 0) {
						// log status
						console.log("status 0")
						setTimeout(poll, 1000);
					} else {
						console.log(res)
						swal.fire({
							title: this.$t(res.data.Msg),
							text: res.data.Cause,
							icon: "error",
							confirmButtonClass: "btn btn-danger btn-fill",
							buttonsStyling: false,
						});
						this.isLoadding = false;
					}

				} catch (err){
					console.log(err)
					swal.fire({
						title: "เกิดข้อผิดพลาด",
						text: err.response.data.Cause,
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
            			buttonsStyling: false,
					  });
					this.isLoadding = false;
				}
			}
			poll();

        },

		async handleDownloadCommissionXLSX(){
			swal.fire({
				title: this.$t(`processing`),
				type: "info",
				allowEscapeKey: false,
				allowOutsideClick: false,
				onOpen: () => {
					swal.showLoading();
				}
			  });
			const dataWS = utils.json_to_sheet(this.tableData)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			await writeFile(wb,`commission_${this.startDate}_${ this.endDate}.xlsx`)
			swal.close();
		}, 
		async handleDownloadOrderDetailXLSX(){
			swal.fire({
				title: this.$t(`processing`),
				type: "info",
				allowEscapeKey: false,
				allowOutsideClick: false,
				onOpen: () => {
					swal.showLoading();
				}
			  });

			const dataWS = utils.json_to_sheet(this.orderDetailTable)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			await writeFile(wb,`orderdetail_${this.startDate}_${ this.endDate}.xlsx`)
			swal.close();

		},


		async handleDownloadXLSX(index,row){

			let dataExport = this.tableData.map((item)=>{
				return {
                    "พนักงาน" : item.Name,
                    "ช่องทางการขาย" : item.BoSaleChannelName,
                    "สินค้า" : item.BoProductName,
                    "จำนวนรายการสั่งซื้อ" : item.Cnt,
                    "จำนวนเงิน" : item.Amount
                }
			})

			const dataWS = utils.json_to_sheet(dataExport)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,`user_product_${this.startDate}_${ this.endDate}.xlsx`)

		},

        selectionChange(selectedRows) {
            this.selectedRows = selectedRows;
        },
		handleProductAdd(){
			// find product with id
			let product = this.ProductTable.find((item)=>{
				return item.id == this.productId
			})

			if (product == undefined) {
				return
			}

			// check product is exist in productSelected
			let isExist = this.productSelected.find((item)=>{
				return item.id == product.id
			})
			if (isExist != undefined) {
				return
			}


			// add product to productSelected
			this.productSelected.push(product);

		},
		handleProductClear(){
			// clear productSelected
			this.productSelected = [];

		}
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
